var MediaDeviceInfoShim = function () {
  function MediaDeviceInfoShim(options) {
    Object.defineProperties(this, {
      deviceId: {
        get: function get() {
          return options.deviceId;
        }
      },
      groupId: {
        get: function get() {
          return options.groupId;
        }
      },
      kind: {
        get: function get() {
          return options.kind;
        }
      },
      label: {
        get: function get() {
          return options.label;
        }
      }
    });
  }

  return MediaDeviceInfoShim;
}();

module.exports = MediaDeviceInfoShim;